// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3z9PO","requiredAsterisk":"Info_requiredAsterisk__3bBoG"};